import styled from 'styled-components'
import { ButtonEdit } from 'Components/Buttons/ButtonEdit'

export const ButtonEditInsideSection = styled(ButtonEdit)`
  & {
    position: absolute !important;
    right: 40px;
    top: 40px;
    width: 44px;
    height: 44px;
    background-color: ${props => props.theme.colors.iron};
    text-align: center;

    svg {
      fill: ${props => props.theme.colors.regentGray};
      width: 20px;
      right: 0;
    }
  }
`



// WEBPACK FOOTER //
// ./src/Components/Buttons/ButtonEditInsideSection/index.js